import './Button.scss';

import classNames from 'classnames';
import type { ButtonHTMLAttributes, DetailedHTMLProps, FC } from 'react';

type HTMLButtonElementProps = DetailedHTMLProps<
  ButtonHTMLAttributes<HTMLButtonElement>,
  HTMLButtonElement
>;

interface Props extends HTMLButtonElementProps {
  acting?: boolean;
  selected?: boolean;
  secondary?: boolean;
  fullwidth?: boolean;
  inline?: boolean;
  testID?: string;
}

const Button: FC<Props> = (props) => {
  const {
    type = 'button',
    disabled = false,
    acting = false,
    selected = false,
    secondary = false,
    fullwidth = false,
    inline = false,
    testID,
    children,
    ...buttonProps
  } = props;

  const className = classNames('Button', {
    'is-acting': acting,
    'is-selected': selected,
    'Button--secondary': secondary,
    'Button--fullwidth': fullwidth,
    'Button--inline': inline,
  });

  return (
    <button
      {...buttonProps}
      className={className}
      type={type}
      disabled={disabled || acting}
      data-test-id={testID}
    >
      {children}
    </button>
  );
};

export default Button;
